export enum Auth {
  Active = "LoginActive",
  InActive = "LoginInActive",
}

export enum Method {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
}

export enum ErrorType {
  TokenExpire = "Token has expired.",
  ScopeError = "Scope not matched",
  InValid = "Invalid Scope in the Token.",
  VersionMissing = "Version is missing in configuration.",
}

export enum Lang {
  En = "En",
  Fr = "Fr",
  EN = "EN",
  FR = "FR",
  en = "en",
  fr = "fr",
  English = "English",
  French = "French",
}

export enum Code {
  Success = 200,
  BadRequest = 400,
  ServiceUnavailable = 503,
  Forbidden = 403,
  ServerError = 500,
  UnAuthorized = 401,
}
